import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';
import { FaCheck } from 'react-icons/fa';
import Select from '../Select';

export const Container = styled.div`
  position: relative;
  margin-bottom: 22px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DefaultSelectWrapper = styled.div`
  position: relative;

  :nth-child(1) {
    width: 37%;
  }

  :nth-child(2) {
    width: 25%;
  }

  :nth-child(3) {
    width: 31%;
  }

  > svg {
    position: absolute;
    right: 0;
    bottom: 5px;
  }

  > select {
    padding: 5px 0 2px 0;
    font-size: 16px;

    ${variants('variant', {
      light: css`
        color: ${({ isPlaceholder }) => (isPlaceholder ? '#949DA5' : th('colors.white'))};
        border-bottom: 1px solid ${th('colors.white')};
      `,
      dark: css`
        color: ${({ isPlaceholder }) => (isPlaceholder ? '#949DA5' : th('colors.black'))};
        border-bottom: 1px solid ${th('colors.black')};
      `,
      small: css`
        color: ${({ isPlaceholder }) => (isPlaceholder ? '#949DA5' : th('colors.white'))};
        border-bottom: 1px solid ${th('colors.white')};
        padding: 0;
        font-size: 14px;
      `
    })}

    > option[disabled] {
      display: none;
    }

    background: transparent;
    font-style: ${({ isPlaceholder }) => (isPlaceholder ? 'italic' : 'normal')};
    width: 100%;
    border-radius: 0;
    -moz-appearance: none;
    -webkit-appearance: none;

    ::-ms-expand {
      display: none;
    }
  }
`;

export const StyledSelect = styled(Select)`
  margin-bottom: 0;

  :nth-child(1) {
    width: 37%;
  }

  :nth-child(2) {
    width: 25%;
  }

  :nth-child(3) {
    width: 31%;
  }
`;

export const DisabledDate = styled.div`
  opacity: 0.7;
`;

export const Error = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const CheckIcon = styled(FaCheck)`
  margin-left: 7px;
  font-size: 14px;
  color: ${th('colors.bermudaGreen')};
`;
